// @flow
import productGridAdapter from '../../../adapters/grid-adapter';

import buildPdsUrl from '../build-pds-url';
import flexFacetsAdapter from '../../../adapters/flex-facets-adapter';
import oldFacetsAdapter from '../../../adapters/facets';
import parseTotalItemCount from '../../parse-total-item-count';

const facetsAdapter = (isFlexFacetsEnabled: boolean): Function =>
  isFlexFacetsEnabled ? flexFacetsAdapter : oldFacetsAdapter;

export default (
  cid: number,
  departmentId: string,
  facetQueryString: string,
  pageId: number,
  productsUrl: string,
  productsApiKey: string,
  hideDepartmentFacet: boolean,
  hidePriceFacet: boolean,
  abSeg: {
    pgAT: string,
    pgBR: string,
    pgGP: string,
    pgON: string,
    pgGPFS: string,
    pgBRFS: string,
    pgATCA: string,
    pgBRCA: string,
    pgGPCA: string,
    pgONCA: string,
  },
  previewState: {},
  isFlexFacetsEnabled: boolean,
  locale: Locale,
  ignoreInventory: boolean,
  isRatingsFacetEnabled: boolean,
  isDynamicStyleFacetNameEnabled: boolean,
  webHierarchy: [],
  SelectedNodes: []
) =>
  fetch(
    buildPdsUrl({
      cid,
      departmentId,
      pageId,
      facetQueryString,
      productsUrl,
      productsApiKey,
      abSeg,
      previewState,
      isFlexFacetsEnabled,
      locale,
      ignoreInventory,
    }),
    {
      credentials: 'same-origin',
      headers: {
        ...(productsApiKey ? { apikey: productsApiKey } : {}),
      },
    }
  )
    .then((data) => data.json())
    .then((data: ProductsResponse) => ({
      gridData: productGridAdapter(data),
      paginator:
        data.productCategoryFacetedSearch.productCategory
          .productCategoryPaginator,
      facetData: facetsAdapter(isFlexFacetsEnabled)(
        data,
        hideDepartmentFacet,
        hidePriceFacet,
        !isRatingsFacetEnabled,
        isDynamicStyleFacetNameEnabled,
        webHierarchy,
        SelectedNodes
      ),
      totalItemCount: parseTotalItemCount(data),
    }));
